import { UiOption } from '@/lib/helpers';
import { BaseMeta } from '../base.model';
import { PublicServiceConfig } from './public-services';
import { PortalConfig, AssistantConfig, DatasourceConfig } from './portal';

export type PolicyType = 'default' | 'override' | 'scoped';

export enum PolicyPriority {
  Override = 1,
  GroupService = 2500,
  Group = 5000,
  Service = 7500,
  Default = 10000,
}

export type PolicyAccessList = {
  enabled: string[];
  disabled: string[];
};

export type PolicyScope = 'org' | 'group';

export type PolicyMergeStrategy = 'least-restrictive' | 'most-restrictive';

export type PolicyMeta = BaseMeta & {
  name: string;
  description: string;
  scope: string;
  groups: string[];
  publicServices: PublicServiceConfig;
  contextDataSources: DatasourceConfig;
  portal: PortalConfig;
  assistants: AssistantConfig;
  isDefault: boolean;
};
// @todo J5 Demo
export const IntentOptions: UiOption[] = [
  'Corporate Social Responsibility',
  'Customer Service Or Support',
  'Engineering',
  'Facilities Management',
  'Finance And Accounting',
  'Health Safety And Environment',
  'Human Resources',
  'Information Technology',
  'Legal And Compliance',
  'Marketing',
  'Operations',
  'Product Management',
  'Public Relations',
  'Purchasing And Procurement',
  'Quality Assurance',
  'Sales',
  'Software And Hardware Development',
  'Strategic Planning And Business Development',
  'Supply Chain And Logistics',
].map((name) => ({ label: name, value: name }));
export type McpAction = 'read' | 'read-write';

export type McpControls = {
  action: McpAction;
  services: PolicyAccessList;
};

export const McpActionOptions: UiOption[] = [
  { label: 'Read-only', value: 'read' },
  { label: 'Read and write', value: 'read-write' },
];

type McpService = {
  name: string;
  id: string;
  providerId: string;
};

export const McpServices: McpService[] = [
  { name: 'CloudFlare Documentation MCP Server', id: 'cf-doc-server', providerId: 'cloudflare' },
  {
    name: 'CloudFlare Workers Bindings MCP Server',
    id: 'cf-workers-bindings-server',
    providerId: 'cloudflare',
  },
  { name: 'CloudFlare Radar MCP Server', id: 'cf-radar-server', providerId: 'cloudflare' },
  { name: 'AWS CloudFormation MCP Server', id: 'aws-cfn-server', providerId: 'aws' },
  { name: 'AWS Documentation MCP Server', id: 'aws-doc-server', providerId: 'aws' },
  { name: 'AWS CDK MCP', id: 'aws-cdk-server', providerId: 'aws' },
  { name: 'AWS Terraform MCP Server', id: 'aws-terraform-server', providerId: 'aws' },
  { name: 'GitHub MCP Server', id: 'github-server', providerId: 'github' },
  { name: 'Azure MCP Server', id: 'azure-server', providerId: 'azure' },
];
